import Marquee from "react-fast-marquee";

const items = [
  "AI-Native Healthcare OS",
  "100% HIPAA Certified",
  "AES-256 Security",
  "Autonomous AI Agents",
  "Live in Days, Not Months",
];

export const EditorialMarquee = () => {
  return (
    <section data-testid="marquee" className="relative z-10 bg-white py-10 md:py-14 border-y border-[#D8E6F1] overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="marquee-text text-5xl md:text-7xl mx-8 flex items-center gap-8 text-[#E7F1F8]">
            {t}
            <span className="text-[#2880B8] text-3xl">✳</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
